import { render, staticRenderFns } from "./industryNews.vue?vue&type=template&id=ab2c1a06&scoped=true"
import script from "./industryNews.vue?vue&type=script&lang=js"
export * from "./industryNews.vue?vue&type=script&lang=js"
import style0 from "./industryNews.vue?vue&type=style&index=0&id=ab2c1a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2c1a06",
  null
  
)

export default component.exports